$(function () {
    // =============================================================================
    // slider
    // =============================================================================
    $('.p__toppage-mainvis').fadeIn(1000);
    defW = 950 //スライド幅
    winW = $(window).width()
    qty1 = $('#slider li').length
    qty2 = Math.round(Math.floor(winW / defW) / 2)
    var slide = $('.p__toppage-mainvis > ul.slider').bxSlider({
        slideWidth  : 950,
        slideMargin : 0,
        pager        : true,
        pagerCustom  : '.thumb',
        controls    : false,
        auto        : true,
        autoControls: false,
        infinityLoop: true,
        speed       : 1000,
        pause       : 3000,
        displaySlideQty : qty1,
        moveSlideQty    : qty2,
        onSlideAfter: function(){
            slide.startAuto();
        }
    });

    // =============================================================================
    // facebook
    // =============================================================================
    var windowWidth = $(window).width();
    var htmlStr = $('.p__fb-box').html();
    var timer = null;
    $(window).on('resize', function () {
        var resizedWidth = $(window).width();
        if (windowWidth != resizedWidth && resizedWidth < 500) {
            clearTimeout(timer);
            timer = setTimeout(function () {
                $('.p__fb-box').html(htmlStr);
                window.FB.XFBML.parse();
                //window.FB.XFBML.parse()で再レンダリングします。
                var windowWidth = $(window).width();
            }, 500);
        }
    });
});

var $modalSetCnt, $modalSetWrap, $win, modalTimer, modalTimerFunc, modalTimerSet, museumsModule, offset;

// =============================================================================
// modal
// =============================================================================
modalTimer = null;
$modalSetWrap = $('#modalCnt');
$modalSetCnt = $('>div', $modalSetWrap);
$win = $(window);
offset = 70;
modalTimerFunc = function() {
    if ($modalSetCnt.height() > $win.height()) {
        $modalSetWrap.css({
            'height': ($win.height() - offset) + 'px',
            'overflow-y': 'scroll',
            'margin-top': ($win.height() - offset) / 2 * -1 + 'px'
        });
    } else {
        $modalSetWrap.css({
            'height': $modalSetCnt.height() + 'px',
            'overflow-y': 'hidden',
            'margin-top': $modalSetCnt.height() / 2 * -1 + 'px'
        });
    }
};
modalTimerSet = function(disable) {
    if (!disable) {
        clearInterval(modalTimer);
    } else {
        modalTimer = setInterval(modalTimerFunc, 250);
    }
};

// //////////////////////////////////////////////////////////////////////////////
//
// 機能
//
// //////////////////////////////////////////////////////////////////////////////

museumsModule = angular.module('museums-module', []);
//==============================================================================
//モデル
//==============================================================================
museumsModule.factory('myModel', [
    function() {
        return {
            modal: false,
            modalData: {}
        };
    }
]);

//==============================================================================
//ポスターディレクティブ
//==============================================================================
//data-xxxを$scopeにリンク
museumsModule.directive('posterDataDicrective', [
    function() {
        return {
            restrict: 'A',
            link: function($scope, $elem, $attrs) {
                $scope.mode = $attrs.mode;
                $scope.modeText = $attrs.modeText;
                $scope.posterID = $attrs.id * 1;
                $scope.period = $attrs.period === '' ? false : $attrs.period;
                $scope.spot = $attrs.spot === '' ? false : $attrs.spot;
                $scope.title = $attrs.title;
                $scope.detailUrl = $attrs.detailUrl === '' ? false : $attrs.detailUrl;
                $scope.poster = $attrs.poster;
            }
        };
    }
]);

//==============================================================================
//ポスターコントローラ
//==============================================================================
museumsModule.controller('posterController', [
    '$scope', 'myModel', function($scope, model) {
        //--------------------------------------------------------------------------
        //サムネイルクリック
        $scope.imgClick = function(e) {
            e.preventDefault();
            model.modalData = {
                mode: $scope.mode,
                modeText: $scope.modeText,
                id: $scope.posterID,
                period: $scope.period,
                spot: $scope.spot,
                title: $scope.title,
                detailUrl: $scope.detailUrl,
                poster: $scope.poster
            };
            model.modal = true;
        };
    }
]);

//==============================================================================
//モーダルコントローラ
//==============================================================================
museumsModule.controller('modalController', [
    '$scope', 'myModel', function($scope, model) {
        $scope.modalFlg = false;
        //console.log model
        $scope.model = model;
        $scope.mode = 'upcomming';
        $scope.modeText = false;
        $scope.title = false;
        $scope.poster = false;
        $scope.period_and_spot = false;
        $scope.detailUrl = false;
        //--------------------------------------------------------------------------
        //モーダル状態の監視
        //--------------------------------------------------------------------------
        $scope.$watch('model.modal', function(word) {
            var _data;
            $scope.modalFlg = word;
            _data = model.modalData;
            $scope.mode = _data.mode;
            $scope.modeText = _data.modeText;
            $scope.title = _data.title;
            $scope.poster = _data.poster;
            $scope.period_and_spot = '';
            if (_data.period) {
                $scope.period_and_spot += _data.period;
            }
            if (_data.period && _data.spot) {
                $scope.period_and_spot += '/';
            }
            if (_data.spot) {
                $scope.period_and_spot += _data.spot;
            }
            if (!_data.period && !_data.spot) {
                $scope.period_and_spot = false;
            }
            $scope.detailUrl = _data.detailUrl;
            if ($scope.modalFlg) {
                modalTimerSet(true);
            } else {
                modalTimerSet(false);
            }
        });
        //--------------------------------------------------------------------------
        //モーダルの背景をクリックしたときの処理
        //--------------------------------------------------------------------------
        $scope.bgClick = function(e) {
            model.modal = false;
        };
        //--------------------------------------------------------------------------
        //閉じるボタンを押したときの処理
        //--------------------------------------------------------------------------
        $scope.closeBtnClick = function(e) {
            model.modal = false;
        };
    }
]);

//==============================================================================
//実行
//==============================================================================
museumsModule.run([
    'myModel', function(model) {
        //--------------------------------------------------------------------------
        //モーダルを表示する
        //--------------------------------------------------------------------------
        $('#modal').css('display', 'block');
        if (directModal) {
            model.modalData = {
                mode: directModal.mode,
                modeText: directModal.modeText,
                id: directModal.posterID,
                period: directModal.period,
                spot: directModal.spot,
                title: directModal.title,
                detailUrl: directModal.detail_url,
                poster: directModal.poster
            };
            model.modal = true;
        }
    }
]);
